const loginRetry = {
    attachLoginRetryReset() {
        if (!this.config.loginRetryReset || !this.form || !this.widget) {
            return
        }

        this.form.onloginError = () => {
            this.resetWidget()
            this.attachFormGate()
            this.attachOffcanvasStart()
        }
    }
}

export default loginRetry
